module.exports = __webpack_public_path__ + "static/media/vintage04.b810dfcc.png";